module.exports = __webpack_public_path__ + "img/hranenie-instrumenta-i-mebel'.3d95a13b.svg";